export const translations = {
  ambassadorsList: {
    it: {
      brand: 'Marca',
      results: 'risultati',
      country: 'Nazione',
      noResults: 'Nessun risultato'
    },
    en: {
      brand: 'Brand',
      results: 'results',
      country: 'Country',
      noResults: 'No results'
    },
    de: {
      brand: 'MARKE',
      results: 'Ergebnisse',
      country: 'Land',
      noResults: 'Keine Ergebnisse'
    },
    fr: {
      brand: 'MARQUE',
      results: 'résultats',
      country: 'Pays',
      noResults: 'Aucun résultat'
    },
  },
  formGenerator: {
    it: {
      checkboxErrorMsg: 'Seleziona almeno una casella di controllo',
      requiredErrorMsg: 'Il campo è obbligatorio',
      fieldErrorMsg: 'errore di convalida nel campo'
    },
    en: {
      checkboxErrorMsg: 'Check at least one checkbox',
      requiredErrorMsg: 'Field is required',
      fieldErrorMsg: 'validation error in the field'
    },
    de: {
      checkboxErrorMsg: 'Aktivieren Sie mindestens ein Kontrollkästchen',
      requiredErrorMsg: 'Feld ist erforderlich',
      fieldErrorMsg: 'Validierungsfehler im Feld'
    },
    fr: {
      checkboxErrorMsg: 'Cochez au moins une case',
      requiredErrorMsg: 'Le champ est obligatoire',
      fieldErrorMsg: 'erreur de validation sur le terrain'
    },
  },
  storeLocator: {
    it: {
      buildRoute: 'ottieni indicazioni',
      DEALER: 'Negozio',
      DISTRIBUTOR: 'Distributore',
      FITTER: 'Fitter',
    },
    en: {
      buildRoute: 'Get directions',
      DEALER: 'Shop',
      DISTRIBUTOR: 'Distributor',
      FITTER: 'Fitter',
    },
    de: {
      buildRoute: 'Wegbeschreibung abrufen',
      DEALER: 'Shop',
      DISTRIBUTOR: 'Großhändler',
      FITTER: 'Sattelfitter',
    },
    fr: {
      buildRoute: 'Obtenir un itinéraire',
      DEALER: 'Magasin',
      DISTRIBUTOR: 'Distributeur',
      FITTER: 'Fitter',
    },
  },
  storiesList: {
    it: {
      brand: 'Brand',
      results: 'risultati',
      storyType: 'Tipologia',
      country: 'Nazione',
      noResults: 'Nessun risultato',
      news: 'NEWS',
      fair: 'FIERE',
      competition: 'COMPETIZIONI'
    },
    en: {
      brand: 'Brand',
      results: 'results',
      storyType: 'Type',
      country: 'Country',
      noResults: 'No results',
      news: 'NEWS',
      fair: 'FAIR',
      competition: 'COMPETITION'
    },
    de: {
      brand: 'Marke',
      results: 'Ergebnisse',
      storyType: 'Typ',
      country: 'Land',
      noResults: 'Keine Ergebnisse',
      news: 'NACHRICHT',
      fair: 'GERECHT',
      competition: 'WETTBEWERB'
    },
    fr: {
      brand: 'MARQUE',
      results: 'résultats',
      storyType: 'Taper',
      country: 'Pays',
      noResults: 'Aucun résultat',
      news: 'NOUVELLES',
      fair: 'ÉQUITABLE',
      competition: 'CONCOURS'
    },
  },
  productList: {
    it: {
      noProductsFound: 'Nessun prodotto trovato.',
      clearFilters: 'Prova a eliminare qualche filtro.',
    },
    en: {
      noProductsFound: 'No products found.',
      clearFilters: 'Try clearing some filters.',
    },
    de: {
      noProductsFound: 'Keine Produkte gefunden.',
      clearFilters: 'Versuchen Sie, einige Filter zu löschen.',
    },
    fr: {
      noProductsFound: 'Aucun produit trouvé.',
      clearFilters: 'Essayez de supprimer certains filtres.',
    },
  }
}
